import { z } from 'zod';

export const countryParamsSchema = z.object({
    tab: z
        .enum(['completed', 'created'])
        .default('completed')
        .catch('completed'),
});

export const defaultCountrySearchParams = countryParamsSchema.parse({});
export type countryParamsType = z.infer<typeof countryParamsSchema>;
